import { isSome } from '../../../utils';

export function isNotDeleted(item: { deleted?: boolean | null }): boolean {
    const { deleted } = item;
    return !isSome(deleted) || !deleted;
}
